import { MessageCircle } from "lucide-react";
import { business } from "../content/site";
import { trackEvent } from "../lib/analytics";
import { useCopy } from "../i18n/copy";

export const WhatsAppFloat = () => {
  const cm = useCopy("common");
  return (
    <a
      href={business.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      onClick={() => trackEvent("whatsapp_click", { location: "floating" })}
      aria-label={cm.whatsapp}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2.5 bg-obsidian text-paper pl-3.5 pr-4 py-3 rounded-full shadow-lg shadow-ink/20 border border-white/10 transition-transform hover:scale-[1.03]"
    >
      <MessageCircle size={19} className="text-emerald-400" aria-hidden="true" />
      <span className="text-xs font-medium tracking-wide hidden sm:inline">{cm.floatWhats}</span>
    </a>
  );
};
